import request from '@/utils/request';

// 公告
function geteduNoticeContentsList(data) {
  return request({
    url: '/whitelist/front/eduNoticeContents/pageList',
    method: 'get',
    params: data
  });
}
// 公告详情
function geteduNoticeContentsDetail(id) {
  return request({
    url: `/whitelist/front/eduNoticeContents/${id}`,
    method: 'get'
  });
}
// 资讯
function geteduInformationList(data) {
  return request({
    url: '/whitelist/front/eduInformationContents/pageList',
    method: 'get',
    params: data
  });
}
// 资讯首页
function geteduInformationListHome(data) {
  return request({
    url: '/whitelist/front/eduInformationContents/list',
    method: 'get',
    params: data
  });
}
function geteduNoticeContentsListHome(data) {
  return request({
    url: '/whitelist/front/eduNoticeContents/list',
    method: 'get',
    params: data
  });
}
function geteduResourceContentsListHome(data) {
  return request({
    url: '/whitelist/front/eduResourceContents/list',
    method: 'get',
    params: data
  });
}
function getSchoolnewsListHome(data) {
  return request({
    url: '/v1/portal/web/whitelist/schoolnews/list',
    method: 'get',
    params: data
  });
}
// 资讯分类
function geteduInformationClassifys() {
  return request({
    url: '/whitelist/front/eduInformationClassifys/allList',
    method: 'get'
  });
}
// 资讯详情
function geteduInformationDetail(id) {
  return request({
    url: `/whitelist/front/eduInformationContents/${id}`,
    method: 'get'
  });
}
// 素质教育
function geteduResourceContentsList(data) {
  return request({
    url: '/whitelist/front/eduResourceContents/pageList',
    method: 'get',
    params: data
  });
}
// 素质教育分类
function geteduResourceClassifys() {
  return request({
    url: '/whitelist/front/eduResourceClassifys/allList',
    method: 'get'
  });
}
// 素质教育详情
function geteduResourceContentsDetail(id) {
  return request({
    url: `/whitelist/front/eduResourceContents/${id}`,
    method: 'get'
  });
}
// 校园动态
function getSchoolnewsList(data) {
  return request({
    url: '/v1/portal/web/whitelist/schoolnews',
    method: 'get',
    params: data
  });
}
// 校园动态分类
function getSchoolnewsClassifys() {
  return request({
    url: '/v1/portal/web/whitelist/schoolnews/classify/list',
    method: 'get'
  });
}
// 校园动态详情
function getSchoolnewsDetail(id) {
  return request({
    url: `/v1/portal/web/whitelist/schoolnews/${id}`,
    method: 'get'
  });
}
// 单页详情
function getEduSinglePagesDetail(data) {
  return request({
    url: `/whitelist/front/eduSinglePages/selectByEntity`,
    method: 'post',
    data: data
  });
}

// 广告
function getSearchitem() {
  return request({
    url: `/v1/portal/web/whitelist/search/item`,
    method: 'get'
  });
}
export default {
  geteduNoticeContentsList,
  geteduNoticeContentsDetail,
  geteduResourceContentsList,
  geteduResourceClassifys,
  geteduResourceContentsDetail,
  geteduInformationList,
  geteduInformationClassifys,
  geteduInformationDetail,
  getEduSinglePagesDetail,
  getSearchitem,
  getSchoolnewsList,
  getSchoolnewsClassifys,
  getSchoolnewsDetail,
  getSchoolnewsListHome,
  geteduResourceContentsListHome,
  geteduNoticeContentsListHome,
  geteduInformationListHome
};
